import Vue from 'vue'

import { store } from '_/vuex/store'

import assetsManagerFactory from '_/vuex/modules/assetsManager'

import _ from 'lodash'

const AssetsManagerModal = Vue.component(
  'AssetsManagerModal',
  require('_/components/FieldTypes/AssetsManager/AssetsManagerModal/AssetsManagerModal.vue')
    .default
)

export default {
  /**
   * Set the data property
   *
   * @return  {object}
   */
  data() {
    return {
      /**
       * Asset manager module id
       *
       * @type  {string}
       */
      id: 'manager',

      /**
       * Sets the asset manager in multiple selection mode
       *
       * @type  {boolean}
       */
      multiple: false,

      /**
       * Asset manager module name
       *
       * @type  {string}
       */
      name: 'main',

      /**
       * Sets the registeredModuleName
       *
       * @type  {string}
       */
      registeredModuleName: 'assetsManager-main-manager',
    }
  },

  /**
   * Set the computed properties
   *
   * @type  {object}
   */
  computed: {
    /**
     * Define the assetsManager getter
     *
     * @return  {object}
     */
    assetsManager() {
      const getterName = `${this.registeredModuleName}/${this.registeredModuleName}`

      return this.$store.getters[getterName]
    },

    /**
     * Gets the assets manager state
     *
     * @return  {boolean}
     */
    assetsManagerVisible() {
      return this.assetsManager.assetsManagerVisible
    },
  },

  /**
   * Set the methods
   *
   * @type  {Object}
   */
  methods: {
    /**
     * Initializes the asset manager
     *
     * @return  {void}
     */
    initializeAssetManager() {
      // Initialize the asset manager state
      store.dispatch('assets/initializeState', {
        multiple: this.multiple,
        value: {},
      })

      // Populate the selectedFiles data property
      store.dispatch('assets/getSelectedAssets', {
        selectedAssetsIds: this.assetsManager.selectedAssetsIds,
      })
    },
  },

  /**
   * Set the created hook
   *
   * @return  {void}
   */
  created() {
    const assetsManagerDynamicModuleName = this.registeredModuleName

    if (!_.has(store.state, assetsManagerDynamicModuleName)) {
      store.registerModule(
        assetsManagerDynamicModuleName,
        assetsManagerFactory(assetsManagerDynamicModuleName)
      )
    }

    store.dispatch(`${this.registeredModuleName}/disableAssetSelection`)
  },

  /**
   * Set the mounted hook
   *
   * @return  {void}
   */
  mounted() {
    this.$nextTick(() => {
      if (this.$route.name !== 'asset-manager') {
        this.initializeAssetManager()
      }
    })
  },
}
